import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';

import history from './history';

const router = routerMiddleware(history);

const middlewares = [thunk, router]

if (process.env.NODE_ENV !== 'production') {
    middlewares.push(logger)
}

export default applyMiddleware(...middlewares);